import React, {

  createContext,

  useContext,

  useEffect,

  useState

} from "react";

import {
  getAuth,
  setAuth,
  clearAuth
}
from "../utils/authStorage";

import {
  authApi
}
from "../../../api/authApi/index";

const AuthContext =
  createContext(null);

export function AuthProvider({
  children
}) {

  const [

    user,

    setUser

  ] = useState(null);

  const [

    loading,

    setLoading

  ] = useState(true);

  const [

    isAuthenticated,

    setIsAuthenticated

  ] = useState(false);

  useEffect(() => {

    restoreSession();

  }, []);

  async function restoreSession() {

    try {

      const auth =
        getAuth();

      if (
        !auth?.accessToken
      ) {

        setLoading(false);

        return;

      }

      const response =
        await authApi.me();

      setUser(
        response.data
      );

      setIsAuthenticated(
        true
      );

    } catch {

      clearAuth();

      setUser(null);

      setIsAuthenticated(
        false
      );

    } finally {

      setLoading(false);

    }

  }

  async function login(
    authData
  ) {

    setAuth(
      authData
    );

    setUser(
      authData.user
    );

    setIsAuthenticated(
      true
    );

  }

  async function logout() {

    try {

      await authApi.logout();

    } catch {}

    clearAuth();

    setUser(null);

    setIsAuthenticated(
      false
    );

  }

  return (

    <AuthContext.Provider

      value={{

        user,

        loading,

        isAuthenticated,

        login,

        logout,

        refresh:
          restoreSession

      }}

    >

      {children}

    </AuthContext.Provider>

  );

}

export function useAuth() {

  return useContext(
    AuthContext
  );

}